// extracted by css-extract-rspack-plugin
export default {"qrCode":"vCVT3cj9","qrCodeClickable":"tilENQO1","qrCodeFullWidth":"eNm0O9Gw"};